import React from 'react';
import { connect } from 'react-redux';
import { selectUserCtn } from "../../../../../../store/callbackRequest/selectors";
import { setCtn } from "../../../../../../store/callbackRequest/slice";
import { getConnectionStatus, getOrderTariffTexts, getTargetTariffType } from "../../../store/selectors/orderTariffCommon";
import { ContentHeader } from "../../common/ContentHeader";
import { ModalLayout } from "../../common/ModalLayout";
// components
import { AddressRequestInputsSection } from "./AddressRequestInputsSection";
import { ConnectionNotification } from "./ConnectionNotification";
import { PhoneInputSection } from "./PhoneInputSection";
var _AddressRequestForm = function _AddressRequestForm(_ref) {
  var _ref$texts = _ref.texts,
    _ref$texts$addressReq = _ref$texts.addressRequestTexts,
    statusConnectionTexts = _ref$texts$addressReq.statusConnectionTexts,
    subtitle = _ref$texts$addressReq.subtitle,
    title = _ref$texts$addressReq.title,
    placeholderAddressTexts = _ref$texts.placeholderAddressTexts,
    ctn = _ref.ctn,
    setPhoneNumber = _ref.setPhoneNumber,
    statusConnection = _ref.statusConnection,
    tariffType = _ref.tariffType;
  return /*#__PURE__*/React.createElement(ModalLayout, {
    "data-t-id": "Steps-AddressRequestForm"
  }, /*#__PURE__*/React.createElement(ContentHeader, {
    subTitle: subtitle,
    title: title,
    "data-t-id": "Steps-AddressRequestForm"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AddressRequestInputsSection, {
    texts: placeholderAddressTexts
  }), /*#__PURE__*/React.createElement(PhoneInputSection
  // @ts-expect-error fix later
  , {
    ctn: ctn,
    setCtn: setPhoneNumber,
    tariffType: tariffType,
    texts: placeholderAddressTexts
  }), /*#__PURE__*/React.createElement(ConnectionNotification, {
    status: statusConnection,
    text: statusConnectionTexts
  })));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    texts: getOrderTariffTexts(state),
    ctn: selectUserCtn(state),
    statusConnection: getConnectionStatus(state),
    tariffType: getTargetTariffType(state)
  };
};
var mapDispatchToProps = {
  setPhoneNumber: setCtn
};
var connector = connect(mapStateToProps, mapDispatchToProps);
export var AddressRequestForm = connector(_AddressRequestForm);